// @ts-nocheck
// tslint:disable
export const WebGL2RenderingContext = {};
